module.exports = __webpack_public_path__ + "img/cloud-plus-fill.a4641799.svg";